import React from 'react';
import "./Searchpage.css";

function SearchPage() {
    return (
        <div className = "searchPage">
            <h2>Hi! I am a Search Page 🔍.</h2>
        </div>
    )
}

export default SearchPage;
